import React from 'react';
import { Globe, Package, Mail, Phone } from 'lucide-react';

const LABEL_CLS = 'text-[10px] uppercase tracking-wider text-earth/40 font-sans font-semibold';

export default function InquiryInfo({ inquiry }) {
  const facts = [
    { label: 'Country', value: inquiry.country, icon: Globe },
    { label: 'Product', value: inquiry.product_interest, icon: Package },
    { label: 'Email', value: inquiry.email, icon: Mail },
    { label: 'Phone', value: inquiry.phone || 'N/A', icon: Phone },
  ];
  return (
    <>
      <div className="grid grid-cols-2 gap-3 mb-4" data-testid="inquiry-info">
        {facts.map(({ label, value, icon: Icon }) => (
          <div key={label} className="bg-cream/50 p-3 rounded-lg">
            <p className={LABEL_CLS}>{label}</p>
            <p className="text-sm text-earth-dark font-sans font-medium flex items-center gap-1 mt-0.5"><Icon size={12} className="text-saffron" /> {value}</p>
          </div>
        ))}
      </div>
      {inquiry.quantity && (
        <div className="bg-cream/50 p-3 rounded-lg mb-3" data-testid="inquiry-quantity">
          <p className={LABEL_CLS}>Quantity</p>
          <p className="text-sm text-earth-dark font-sans mt-0.5">{inquiry.quantity}</p>
        </div>
      )}
      {inquiry.message && (
        <div className="bg-cream/50 p-3 rounded-lg mb-4" data-testid="inquiry-message">
          <p className={LABEL_CLS}>Message</p>
          <p className="text-sm text-earth/70 font-sans mt-0.5">{inquiry.message}</p>
        </div>
      )}
    </>
  );
}
